const sectionNav = document.querySelector('.nav-section');
const sectionNavButton = document.querySelector('.nav-section__button');

// Check window size
function sectionNavDisplay() {
  if (window.innerWidth > 900) {
    // Show section nav
    sectionNav.hidden = false;
  } else {
    // Hide section nav
    sectionNav.hidden = true;
    sectionNavButton.setAttribute('aria-expanded', 'false');
  }
}

// If section nav is present
if (sectionNav) {
  // Show/hide section nav on page load
  sectionNavDisplay();

  // Show/hide section nav on resize
  window.addEventListener('resize', () => {
    sectionNavDisplay();
  });

  // On section nav button click
  sectionNavButton.addEventListener('click', () => {
    // Toggle button attributes
    const sectionNavExpanded = sectionNavButton.getAttribute('aria-expanded') === 'true' || false;
    sectionNavButton.setAttribute('aria-expanded', !sectionNavExpanded);

    // Toggle section nav display
    sectionNav.hidden = !sectionNav.hidden;
  });
}
